import { get } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { getCurrentFactors, getTotalRow, getCategories, getSelectedFactorCategory, getSelectedMetricType, getMetricTypeOptions, getCumulativeReturnCurrencyScale } from "./selectors/data"
import { MODEL_METADATA_QUERY } from "resources/models"
import { getIsRfrAttributionEnabled } from "selectors/features"

export default createModule({
  view,
  externalProps: (state, props) => ({
    isRfrAttributionEnabled: getIsRfrAttributionEnabled(state, props),
  }),
  required: ["account", "modelId", "positionSet", "startDate", "endDate"],
  data: [{
    resource: "analyzeFactorsPerformance",
    as: null,
    url: ({ modelId, startDate, endDate, segment, isActive, base, baseSignature, positionSet, currency, fxHedgeEnabled, isRfrAttributionEnabled }) => {
      const { type, id } = positionSet
      return ({
        id: `analyzeFactorsPerformance-${modelId}${id}${startDate}${endDate}${JSON.stringify(segment)}${isActive}${baseSignature}${currency}${fxHedgeEnabled}${isRfrAttributionEnabled}`,
        query: `query ($modelId: String!, $type: PositionSetType, $id: String!, $from: Date!, $to: Date!, $base: [PositionSetInput], $segment: Segment, $useModelRiskFreeRate: Boolean) {
          model(id: $modelId) {
            simulation(positionSet: {type: $type, id: $id, segment: $segment}, from: $from, to: $to, base: $base, interval: AUTO) {
              performance{
                date
                totalReturn {
                  cumulativePercent
                  cumulativeCurrency
                }
                attribution{
                  summary{
                    factors {
                      cumulativePercent
                      cumulativeCurrency
                    }
                    specific {
                      cumulativePercent
                      cumulativeCurrency
                    }
                  }
                  factors{
                    id
                    return {
                      cumulativePercent
                      cumulativeCurrency
                    }
                  }
                }
              }
              periodPerformance(useModelRiskFreeRate: $useModelRiskFreeRate){
                annualizedReturns
                annualizedVolatility
                informationRatio
                attribution{
                  summary{
                    factors{
                      annualizedReturns
                      annualizedVolatility
                      informationRatio
                    }
                    specific{
                      annualizedReturns
                      annualizedVolatility
                      informationRatio
                    }
                  }
                  factors{
                    id
                    annualizedReturns
                    annualizedVolatility
                    informationRatio
                  }
                }
              }
            }
          }
        }`,
        variables: {
          from: startDate,
          to: endDate,
          base: isActive ? [base] : undefined,
          modelId,
          type,
          id,
          segment,
          useModelRiskFreeRate: !isActive && isRfrAttributionEnabled,
        },
      })
    },
  },
  MODEL_METADATA_QUERY,
  ],
  actions: {
    ...Creators,
  },
  mapStateToProps: (state, props) => ({
    ...get(state, "modules.analyzeFactorsPerformance"),
    selectedFactorCategory: getSelectedFactorCategory(state, props),
    categories: getCategories(state, props),
    factors: getCurrentFactors(state, props),
    totalRow: getTotalRow(state, props),
    currencyScale: getCumulativeReturnCurrencyScale(state, props),
    metricType: getSelectedMetricType(state, props),
    metricTypeOptions: getMetricTypeOptions(state, props),
  }),
})
